import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

interface ICountDownProps {
  maxSeconds: number;
  setBtnState: Dispatch<
    SetStateAction<{
      disabled: boolean;
      resetCount: number;
    }>
  >;
}

const CountDown = ({ setBtnState, maxSeconds }: ICountDownProps) => {
  const [counter, setCounter] = useState(maxSeconds);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCounter(prev => {
        if (prev <= 1) {
          clearInterval(intervalId);
          setBtnState(prevState => ({ ...prevState, disabled: false }));
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <span>Resend code {counter > 0 ? `(${counter})` : ''}</span>;
};

export default CountDown;
